import React from "react";
import {
  Select as AntSelect,
  SelectProps as AntSelectProps,
  ConfigProvider,
} from "antd";

interface SelectProps {
  allowClear?: boolean;
  autoClearSearchValue?: boolean;
  className?: string;
  defaultValue?: string | string[] | number | number[];
  disabled?: boolean;
  fullWidth?: boolean;
  id: string;
  listHeight?: number;
  label?: string;
  loading?: boolean;
  maxCount?: number;
  maxTagCount?: number | "responsive";
  maxTagTextLength?: number;
  mode?: "multiple" | "tags";
  notFoundContent?: React.ReactNode;
  open?: boolean;
  optionRender?: (option: any) => React.ReactNode;
  options: { label: string; value: any }[];
  placeholder?: string;
  placement?: "topLeft" | "bottomLeft" | "topRight" | "bottomRight";
  showSearch?: boolean;
  size?: "small" | "middle" | "large";
  status?: "error" | "warning";
  tokenSeparators?: string[];
  type?: "outlined" | "filled" | "borderless";
  value?: string | string[] | number | number[];
  onChange?: (
    value: string | string[] | number | number[] | undefined,
    option?: any
  ) => void;
  onClear?: () => void;
  onDeselect?: (value: string | number) => void;
  onSearch?: (value: string | number) => void;
  onSelect?: (value: string | number) => void;
  disableBg?: boolean;
  popupClassName?: string;
  onDropdownVisibleChange?: (open: boolean) => void;
}

export const Select: React.FC<SelectProps> = ({
  allowClear = false,
  autoClearSearchValue = true,
  listHeight = 256,
  placement = "bottomLeft",
  type = "outlined",
  fullWidth = true,
  ...props
}) => {
  const filterOption = (
    input: string,
    option?: { label: string; value: string }
  ) => (option?.label ?? "")?.toLowerCase()?.includes(input?.toLowerCase());

  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Select: {
              optionSelectedBg: "var(--color-primary-light)",
              colorTextDisabled: "#00000",
              colorBgContainerDisabled: props.disableBg ? "#ffff" : "#f5f5f5",
            },
          },
        }}
      >
        {props?.label && (
          <label
            htmlFor={props.id}
            className="text-sm block font-semibold mb-4 text-gray-600"
          >
            {props?.label}
          </label>
        )}
        <AntSelect
          allowClear={allowClear}
          autoClearSearchValue={autoClearSearchValue}
          filterOption={filterOption}
          listHeight={listHeight}
          placement={placement}
          variant={type}
          className={`${fullWidth ? " w-full" : ""} no-outline  ${
            props?.className
          }`}
          {...props}
        />
      </ConfigProvider>
    </>
  );
};
